import { GET } from 'utils/requests.utils'

const BASE_URL = '/common/vat_ids'

export const fetchItem = (id) => GET(`${BASE_URL}/${id}`)
